import React from 'react';
import './skills.css';
import css from '../images/css_logo.png';
import git from '../images/git_logo.png';
import html from '../images/html_logo.png';
import javascript from '../images/javascript_logo.png';
import postgres from '../images/postgres_logo.png';
import rails from '../images/rails_logo.png';
import react from '../images/react_logo.png';
import redux from '../images/redux_logo.png';
import Rspec from '../images/Rspec_logo.png';
import ruby from '../images/ruby.png';
import sql from '../images/sql_logo.png';

const Skills = () => {
  const skills = [react, redux, ruby, rails, javascript, html, css, sql,
    postgres, Rspec, git];
  return (
    <div className="skills-main">
      <ul className="skills-list">
        {skills.map(skill => {
          return (
            <li className="skill-icon"><img src={skill}/></li>
          );
        })}
      </ul>
    </div>
  );
};

export default Skills;



// WEBPACK FOOTER //
// ./src/pages/skills.jsx